import { useMemo } from "react"
import { ICircle } from "../../../../types/wizard"

interface ILeatherEmblemSummary {
  items: ICircle[]
}

export default function LeatherEmblemSummary({ content }: { content: ILeatherEmblemSummary }) {
  const leathers = useMemo(() => content?.items?.filter((item) => item.option === 'leather'), [content?.items])
  const engraveds = useMemo(() => content?.items?.filter((item) => item.option === 'engraved'), [content?.items])

  return (
    <div className="flex flex-col gap-4">
      {leathers?.length ? (
        <div className="flex flex-col items-start">
          <h2 className="font-bold">{leathers.length} Leather Finish Engravings Indicated</h2>
          {leathers.map((leather, index) => (
            <div className="flex items-center gap-2 mt-2" key={index}>
              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: leather.color! }}></div>
              {leather.label}
            </div>
          ))}
        </div>
      ): null}
      {engraveds?.length ? (
        <div className="flex flex-col items-start">
          <h2 className="font-bold">{engraveds.length} Engraved Finish Engravings Indicated</h2>
          {engraveds.map((engraved, index) => (
            <div className="flex items-center gap-2 mt-2" key={index}>
              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: engraved.color! }}></div>
              {engraved.label}
            </div>
          ))}
        </div>
      ): null}
    </div>
  )
}